module.exports = __webpack_public_path__ + "img/aig.e07b18b9.svg";